import { render, staticRenderFns } from "./DonorEdit.vue?vue&type=template&id=517f31a4&"
import script from "./DonorEdit.vue?vue&type=script&lang=ts&"
export * from "./DonorEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports